import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { DocFact } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

/**
 * Fetches lightweight document facts for the doc viewer sidebar.
 * Returns only essential fields needed for display and PDF highlighting.
 */
export const useGetDocFacts = (
  matterId: string | null | undefined,
  subsetId: string | null | undefined,
  docId: string | null | undefined,
) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DocFact[], Error>(
    [QueryEntity.DocSubsetFacts, { docId }, { subsetId }],
    async () => {
      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/subsets/${subsetId}/docs/${docId}/facts`,
        fetchConfigGET,
      );
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    { refetchOnWindowFocus: false, enabled: !!matterId && !!subsetId && !!docId },
  );
};
